function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Q-Codes_Icon");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Sections-Survey-q-codes",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.2---Content-page",
  transform: "translate(-23.000000, -848.000000)",
  fill: "#888888",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "settings_input_component-24px-(1)",
  transform: "translate(23.000000, 848.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16,16 L2,16 L2,2 L9,2 L9,0 L2,0 C0.89,0 0,0.9 0,2 L0,16 C0,17.1 0.89,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,9 L16,9 L16,16 L16,16 Z M11,0 L11,2 L14.59,2 L4.76,11.83 L6.17,13.24 L16,3.41 L16,7 L18,7 L18,0 L11,0 L11,0 Z",
  id: "path-1"
}))));

function SvgViewSurveyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "22px",
    viewBox: "0 0 18 22"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "1e2a99f847be2ee77fcbf66fd7cfa802.svg";
export { SvgViewSurveyIcon as ReactComponent };